// extracted by mini-css-extract-plugin
module.exports = {"filterBackground":"ProductDefinitionSection_filterBackground__B6lrX"};